// User service for API calls
import {User} from '../types';
import { fetchWithErrorHandling } from './apiUtils';


// API response uses snake_case, we need to transform to camelCase
interface UserApiResponse {
    id: number;
    email: string;
    alt_username?: string;
    fastpass?: string | null;
    fullName: string;
    phone: string;
    fax: string;
    mobile: string;
    accounting_code: string | null;
    departments?: Array<{
        id: number;
        name: string;
        active: boolean;
        client_id: number;
    }>;
    switched: boolean;
    api_token?: string;
    client?: {
        id: number;
        client: string;
        phone: string;
        fax: string;
        [key: string]: unknown;
    };
    active?: boolean;
    disable?: boolean;
    admin?: boolean;
    bulk_order?: boolean;
    location_id?: number;
    priv_order?: boolean;
    priv_pay_account?: boolean;
    priv_pay_card?: boolean;
    rights_admin?: boolean;
    rights_reports?: boolean;
    restricted?: boolean;
    shipping_allow_local_pickup?: boolean;
    shipping_allow_external?: boolean;
    shipping_allow_one_day?: boolean;
    shipping_allow_two_day?: boolean;
    shipping_allow_ground?: boolean;
    shipping_allow_economy?: boolean;
    shipping_allow_weekend_delivery?: boolean;
    client_id?: number;
    priv_all?: boolean;
    priv_email?: boolean;
    priv_user?: boolean;
    rights_account?: boolean;
    rights_help?: boolean;
    rights_orders?: boolean;
    rights_queue?: boolean;
    rights_ware?: boolean;
}

function transformUserResponse(apiUser: UserApiResponse): User {
    return {
        id: apiUser.id,
        email: apiUser.email,
        altUsername: apiUser.alt_username,
        fastpass: apiUser.fastpass ?? undefined,
        fullName: apiUser.fullName,
        phone: apiUser.phone,
        fax: apiUser.fax,
        mobile: apiUser.mobile,
        accountingCode: apiUser.accounting_code,
        departments: apiUser.departments,
        switched: apiUser.switched,
        apiToken: apiUser.api_token,
        client: apiUser.client,
        active: apiUser.active,
        disable: apiUser.disable,
        admin: apiUser.admin,
        bulkOrder: apiUser.bulk_order,
        locationId: apiUser.location_id,
        privOrder: apiUser.priv_order,
        privPayAccount: apiUser.priv_pay_account,
        privPayCard: apiUser.priv_pay_card,
        rightsAdmin: apiUser.rights_admin,
        rightsReports: apiUser.rights_reports,
        restricted: apiUser.restricted,
        shippingAllowLocalPickup: apiUser.shipping_allow_local_pickup,
        shippingAllowExternal: apiUser.shipping_allow_external,
        shippingAllowOneDay: apiUser.shipping_allow_one_day,
        shippingAllowTwoDay: apiUser.shipping_allow_two_day,
        shippingAllowGround: apiUser.shipping_allow_ground,
        shippingAllowEconomy: apiUser.shipping_allow_economy,
        shippingAllowWeekendDelivery: apiUser.shipping_allow_weekend_delivery,
        clientId: apiUser.client_id,
        privAll: apiUser.priv_all,
        privEmail: apiUser.priv_email,
        privUser: apiUser.priv_user,
        rightsAccount: apiUser.rights_account,
        rightsHelp: apiUser.rights_help,
        rightsOrders: apiUser.rights_orders,
        rightsQueue: apiUser.rights_queue,
        rightsWare: apiUser.rights_ware,
    };
}

// API response uses snake_case, we need to transform to camelCase
interface UserApiResponse {
    id: number;
    email: string;
    alt_username?: string;
    fastpass?: string | null;
    fullName: string;
    phone: string;
    fax: string;
    mobile: string;
    accountingCode: string | null;
    departments?: Array<{
        id: number;
        name: string;
        active: boolean;
        client_id: number;
    }>;
    switched: boolean;
    api_token?: string;
    client?: {
        id: number;
        client: string;
        phone: string;
        fax: string;
        [key: string]: unknown;
    };
    active?: boolean;
    disable?: boolean;
    admin?: boolean;
    bulk_order?: boolean;
    location_id?: number;
    priv_order?: boolean;
    priv_pay_account?: boolean;
    priv_pay_card?: boolean;
    rights_admin?: boolean;
    rights_reports?: boolean;
    restricted?: boolean;
    shipping_allow_local_pickup?: boolean;
    shipping_allow_external?: boolean;
    shipping_allow_one_day?: boolean;
    shipping_allow_two_day?: boolean;
    shipping_allow_ground?: boolean;
    shipping_allow_economy?: boolean;
    shipping_allow_weekend_delivery?: boolean;
    client_id?: number;
    priv_all?: boolean;
    priv_email?: boolean;
    priv_user?: boolean;
    rights_account?: boolean;
    rights_help?: boolean;
    rights_orders?: boolean;
    rights_queue?: boolean;
    rights_ware?: boolean;
}

export class UserService {
    static async getCurrentUser(): Promise<User> {
        const endpoint = `/api/v2/users/me`;
        const apiResponse = await fetchWithErrorHandling<UserApiResponse>(endpoint);
        return transformUserResponse(apiResponse);
    }
}
